<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-card>
      <b-row>
        <b-col md="12">
          <div v-if="tempUserInfo.updateType === 'firstUpdate'">
            You must change your password before logging on for the first time. Please update your password.
          </div>
          <div v-if="tempUserInfo.updateType === 'overtimeUpdate'">
            Your password is expired, please update your password.
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <!-- form -->
      <b-form>
        <b-row>
          <!-- old password -->
          <b-col md="6">
            <b-form-group
              label="Old Password"
              label-for="account-old-password"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-old-password"
                  v-model="form.oldPassword"
                  name="old-password"
                  :type="passwordFieldTypeOld"
                  placeholder="Old Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconOld"
                    class="cursor-pointer"
                    @click="togglePasswordOld"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              label-for="account-new-password"
              label="New Password"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-new-password"
                  v-model="form.newPassword"
                  :type="passwordFieldTypeNew"
                  name="new-password"
                  placeholder="New Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconNew"
                    class="cursor-pointer"
                    @click="togglePasswordNew"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <!-- retype password -->
          <b-col md="6">
            <b-form-group
              label-for="account-retype-new-password"
              label="Retype New Password"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-retype-new-password"
                  v-model="form.newPassword1"
                  :type="passwordFieldTypeRetype"
                  name="retype-password"
                  placeholder="New Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconRetype"
                    class="cursor-pointer"
                    @click="togglePasswordRetype"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!--/ retype password -->
          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              @click="changePassword"
            >
              Save Changes
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              class="mt-1"
            >
              Reset
            </b-button>
          </b-col>
        <!--/ buttons -->
        </b-row>
      </b-form>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import md5 from 'js-md5'
import { deepClone } from '@/util/util'
import { updatePassword, updatePasswordNoToken } from '@/api/user'
import { mapGetters } from 'vuex';

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    // 首次更新 firstUpdate 超时更新 overtimeUpdate
    // updateType: {
    //   type: String,
    //   default: 'firstUpdate',
    // },
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      updateType: 'firstUpdate',
      loading: false,
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    ...mapGetters(['isInitPasswordFlag', 'userAllInfo', 'tempUserInfo']),
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    clear() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      }
    },
    changePassword() {
      this.loading = true
      const tempForm = deepClone(this.form)
      if (tempForm.newPassword === 'mcc123456') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.updatePassword.check1'),
            variant: 'danger',
          },
        })
        this.loading = false
        return
      }
      if (tempForm.oldPassword === tempForm.newPassword) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.updatePassword.check2'),
            variant: 'danger',
          },
        })
        this.loading = false
        return
      }
      if (tempForm.newPassword !== tempForm.newPassword1) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.updatePassword.check3'),
            variant: 'danger',
          },
        })
        this.loading = false
        return
      }
      // ^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$
      // updatePassword(tempForm).then(res => {
      //   this.loading = false
      //   this.$store.commit('getIsInitPassWordStatus', false)
      //   this.clear()
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: this.$t('_default.toast.title'),
      //       icon: 'BellIcon',
      //       text: this.$t('_default.toast.text.success'),
      //       variant: 'success',
      //     },
      //   })
      // })
      const header = {
        Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
        'Blade-Auth': `bearer ${this.tempUserInfo.access_token}`,
      }
      updatePasswordNoToken(tempForm, header).then(res => {
        this.loading = false
        this.$store.commit('getIsInitPassWordStatus', false)
        this.clear()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      }).catch(e => {
        this.loading = false
      })
    },
  },
}
</script>
